import clsx from 'clsx';
import { createElement } from 'react';

import type {tags} from './tags';

const variants = {
  title: 'text-3xl! font-semibold!',
  subtitle: 'text-2xl! font-semibold!',
  upper: 'text-sm! font-semibold! uppercase!',
} as const;

type Props = React.HTMLAttributes<HTMLHeadingElement> & {
  as?: keyof typeof variants;
  tag?: (typeof tags)[number];
  children: React.ReactNode;
};
export const Heading = (
  {
    ref,
    as = 'subtitle',
    tag = 'h2',
    children,
    className,
    ...props
  }: Props & {
    ref?: React.RefObject<HTMLParagraphElement>;
  }
) => {
  const style = clsx(['mb-2', className, variants[as]]);
  return createElement(tag, {...props, className: style, ref}, children);
};

Heading.displayName = 'Heading';
